import React from "react";

const ContactUs = () => {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "30px 20px",
        lineHeight: "1.7",
        color: "#333",
        textAlign: "left",
      }}
    >
      <h1
        style={{
          marginBottom: "20px",
          fontSize: "2rem",
          color: "#222",
          fontWeight: "600",
          textAlign: "left",
        }}
      >
        Contact Us – Speak Bold with KK
      </h1>

      <p>
        We are always here to help you. If you have any questions, feedback, or
        support requests, feel free to reach out to us. You will receive a
        response within <strong>24–48 hours</strong>.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          fontWeight: "500",
          textAlign: "left",
        }}
      >
        How to Reach Us
      </h2>
      <p>
        Please send your queries or feedback via email:
      </p>
      <p>
        <strong>Email:</strong> support@speakboldwithkk.com
      </p>
    </div>
  );
};

export default ContactUs;
